import React from "react";
import SEOLandingPage from "./SEOLandingPage";

const JsonViewerAndroid: React.FC = () => (
  <SEOLandingPage
    title="JSON Viewer for Android — Browse, Format & Edit JSON on Mobile | Cosmovex"
    metaDescription="JSONVEdit is a JSON viewer and editor for Android. Open JSON files, explore the object tree, format ugly JSON, validate syntax, and edit — all on your phone."
    ogTitle="JSON Viewer for Android — JSONVEdit"
    h1="JSON Viewer for Android"
    intro="Stop squinting at raw JSON on your phone. JSONVEdit parses JSON instantly, shows you a navigable tree, and lets you edit — clean, fast, and mobile-native."
    paragraphs={[
      "JSON is the universal data format of modern software. API responses, configuration files, data exports, Firebase documents — they're all JSON. JSONVEdit gives Android users a tool that treats JSON with the respect it deserves: parsed into a readable tree, not displayed as a raw string.",
      "The tree view makes JSON structure immediately obvious. Objects show their keys. Arrays show their length and items. Nested structures collapse to keep the view manageable. You can tap any node to expand or collapse it, long-press to copy a value, and search across the entire document for a specific key or value.",
      "JSONVEdit validates your JSON in real time. Missing commas, unclosed brackets, trailing commas in strict mode — errors are flagged with the specific line and character position. For developers copying JSON from various sources, automatic validation prevents errors from propagating further.",
      "The formatting tools are simple but essential. Paste minified JSON and tap Format to get a properly indented, readable document. Tap Minify to compact it back for transmission. These operations work instantly even on large documents. Copy the result, share it, or save it to a file.",
    ]}
    features={[
      "Collapsible JSON tree with expand/collapse all",
      "Real-time JSON validation with error location",
      "Format (prettify) minified JSON instantly",
      "Minify JSON to compact form",
      "Search across keys and values",
      "Copy any value or subtree to clipboard",
      "Edit values inline in the tree",
      "Support for large JSON files",
      "Import from clipboard or open from storage",
      "Share formatted or raw JSON to other apps",
    ]}
    playStoreUrl="https://play.google.com/store/apps/details?id=com.cosmovex.jsonvedit"
    icon="/images/jsonvedit.png"
    appName="JSONVEdit"
    accentColor="#A8720E"
    canonicalPath="/json-viewer-android"
  />
);

export default JsonViewerAndroid;
